module.exports = __webpack_public_path__ + "img/c2.f6abbf7e.png";